var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.url,"target":_vm.target},on:{"click":_vm.handle}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }